import { AlertBox } from '@iwoca/orion';
import { clsx } from 'clsx';
import { useParams } from 'react-router';

import externalLinkSVG from '../../../../assets/externalLink.svg';
import { useGetCustomerEmail } from '../../../../hooks/useGetCustomerEmail';
import rocket from '../../assets/rocket.svg';
import tickSVG from '../../assets/tick.svg';
import { useGetIntegrationStatus } from '../../hooks/useGetIntegrationStatus.hook';
import { Shopify } from '../../Integrations';
import { integrationNameToPlatformNameMap } from '../../utils/integrationNameToPlatformNameMap';
import { postInterestToHubspot } from '../../utils/postInterestToHubspot';
import { ConnectButton } from '../ConnectButton/ConnectButton';
import { IntegrationsTitle } from '../IntegrationsTitle/IntegrationsTitle';

export function ShopifyBody() {
  const { integrationParam } = useParams();
  const { integrationStatus, loadingIwocapaySellerConnection } =
    useGetIntegrationStatus({
      integrationId: Shopify.id,
    });
  const email = useGetCustomerEmail();

  const isConnected = integrationStatus === 'CONNECTED';

  const buttonText = isConnected ? 'Manage on Shopify' : 'Install plugin';

  const handleButtonClick = async () => {
    const buttonLink =
      'https://accounts.shopify.com/store-login?redirect=%2Fadmin%2Fsettings%2Fpayments%2Falternative-providers%2F33619969';

    const hubspotPlaformName = integrationNameToPlatformNameMap['shopify'];

    if (hubspotPlaformName && !isConnected) {
      await postInterestToHubspot({
        email: email!,
        platform: hubspotPlaformName,
      });
    }
    window.location.href = buttonLink;
  };

  if (integrationParam !== Shopify.id) {
    return null;
  }
  if (loadingIwocapaySellerConnection) {
    return null;
  }
  return (
    <div className="text-left">
      <div className="flex flex-wrap items-center justify-between max-800:flex-col max-800:items-start max-800:pt-[2.25rem]">
        <IntegrationsTitle integration={Shopify} />
        <div
          className={clsx('max-800:w-full max-800:pt-l', {
            'flex flex-col items-end max-800:flex-row max-800:justify-between':
              isConnected,
          })}
        >
          {isConnected && (
            <div className="pb-s pt-l text-end text-l font-bold text-success-drk max-800:mb-auto max-800:mt-auto max-800:p-0">
              <img src={tickSVG} alt="Tick Icon" className="pr-[0.7rem]" />
              Connected
            </div>
          )}
          <ConnectButton
            isConnected={isConnected}
            onClick={handleButtonClick}
            className={clsx({
              'max-600:w-full': !isConnected,
              'max-600:w-auto': isConnected,
            })}
          >
            {buttonText}
          </ConnectButton>
        </div>
      </div>
      <div className="border-b border-structure-80 pb-[3rem] text-m font-reg">
        <div>
          <p>
            {isConnected ? (
              <>
                <AlertBox
                  variant="connect"
                  className="mb-[28px] flex items-start gap-m text-s font-reg"
                >
                  <img src={rocket} alt="rocket" />
                  <div>
                    <b>Supercharge your conversion &mdash; </b>
                    We’ve made launching iwocaPay on Shopify 2.0 even easier
                    with on-site messaging built in. Just go to your theme
                    editor in Shopify 2.0 to add iwocaPay banners advertising
                    pay later to your site in just a few clicks.
                  </div>
                </AlertBox>
                Build your business with Shopify &mdash; the global commerce
                platform - to sell online, offline, and everywhere in between.
              </>
            ) : (
              <>
                The global commerce platform. Build your business with Shopify
                to sell online, offline, and everywhere in between.
              </>
            )}
          </p>
          <h3 className="mb-0 text-m font-bold">
            When you connect iwocaPay to Shopify it'll automatically:
          </h3>
          <ul className="mt-s">
            <li>add iwocaPay as a payment method on your Shopify checkout</li>
            <li>
              reconcile all iwocaPay payments with your Shopify store data.
            </li>
          </ul>
          <div>
            <a
              href={
                'https://ecommerce-api.iwoca.com/guides/plugin-solution/shopify/'
              }
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center pt-[1.25rem] text-m font-bold text-primary-40 no-underline"
            >
              Shopify FAQs
              <img
                src={externalLinkSVG}
                alt="External Link Icon"
                className="pl-s"
              />
            </a>
          </div>
        </div>
      </div>
      <div className="inline-flex pt-[3rem] max-800:block max-800:w-full">
        {isConnected ? (
          <div className="text-start text-l font-bold text-success-drk">
            <img src={tickSVG} alt="Tick Icon" className="pr-[0.7rem]" />
            Connected
          </div>
        ) : (
          <ConnectButton onClick={handleButtonClick} className="max-600:w-full">
            {buttonText}
          </ConnectButton>
        )}
      </div>
    </div>
  );
}
